import React from 'react';
import { Card, CardContent, Skeleton } from '@mui/material';

interface CardSkeletonProps {
  /**
   * Number of text lines (default: 3)
   */
  lines?: number;

  /**
   * Show title skeleton (default: true)
   */
  showTitle?: boolean;

  /**
   * Card height (default: auto)
   */
  height?: number | string;
}

/**
 * Skeleton loader for cards
 * Displays animated skeleton content while card data is loading
 */
export const CardSkeleton: React.FC<CardSkeletonProps> = ({
  lines = 3,
  showTitle = true,
  height = 'auto',
}) => {
  return (
    <Card sx={{ height }}>
      <CardContent>
        {showTitle && (
          <Skeleton
            data-testid="card-skeleton-title"
            variant="text"
            width="60%"
            height={32}
            sx={{ mb: 2 }}
          />
        )}
        {Array.from({ length: lines }).map((_, index) => (
          <Skeleton
            key={index}
            data-testid="card-skeleton-line"
            variant="text"
            width={index === lines - 1 ? '40%' : '90%'}
            sx={{ mb: 1 }}
          />
        ))}
      </CardContent>
    </Card>
  );
};
